<script setup>
import { onMounted, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useAppStore } from '@/store/app';
import AddProduct from './AddProduct.vue';
// Components
import Product from './Product.vue';
import Loader from './Loader.vue';
const store = useAppStore();
const router = useRouter();

onMounted(() => {
  store.appLoading = true;
  store.fetchAllBetMakersProducts();
  store.fetchActiveAndInactiveUsers();
  store.appLoading = false;
});

/**
 * Navigate admin to new page when a product is selected
 */
const onNavigateToProduct = ({ product }) => {
  store.setSelectedProduct({ productName: product.name });
  router.push(`/${product.id}/subscriptions`);
};

const showNewProductModal = ref(false);

const msgToUser = reactive({
  show: false,
  message: '',
  success: false,
});

const onAddEditProductClose = (data) => {
  msgToUser.success = data?.success;
  msgToUser.message = data?.message;
  showNewProductModal.value = false;
  msgToUser.show = data?.message ? true : false;
  store.fetchAllBetMakersProducts();
  store.appLoading = false;
};

const editProduct = ref({});
const isNewProduct = ref(true);

const onEditProduct = (product) => {
  editProduct.value = product;
  isNewProduct.value = false;
  showNewProductModal.value = true;
};
</script>

<template>
  <v-btn
    class="ma-2"
    color="primary"
    prepend-icon="mdi-plus"
    @click="
      (isNewProduct = true),
        (showNewProductModal = true),
        store.setSelectedProduct({ productName: '' }) // Set to default
    ">
    New Product
  </v-btn>
  <Loader></Loader>
  <v-sheet class="products d-flex justify-between">
    <Product
      v-for="product in store.products"
      :key="product.id"
      :product="product"
      :onNavigateToProduct="onNavigateToProduct"
      @on-edit-product="onEditProduct" />
  </v-sheet>
  <AddProduct
    v-if="showNewProductModal"
    @on-close="onAddEditProductClose"
    :isNew="isNewProduct"
    :product="editProduct" />
  <v-snackbar
    location="top center"
    v-model="msgToUser.show"
    :timeout="2000"
    :color="msgToUser.success ? 'success' : 'error'">
    {{ msgToUser.message }}
  </v-snackbar>
</template>

<style lang="scss">
.products {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  background-color: transparent;
}
</style>
